(() => {
  'use strict';
  const configNode = document.getElementById('BeerClubGtmConfig');
  if (!configNode || window.BeerClubGtmInitialized) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const id = String(config.id || '').trim().toUpperCase();
  if (!/^GTM-[A-Z0-9]+$/.test(id)) return;
  window.BeerClubGtmInitialized = true;
  const layer = window.dataLayer = window.dataLayer || [];
  function consent() { layer.push(arguments); }
  const denied = { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', personalization_storage: 'denied' };
  consent('consent', 'default', denied);
  let loaded = false, lastState = '', attempts = 0;
  function load() {
    const ageGate = document.querySelector('[data-age-gate]');
    if (loaded || (ageGate && ageGate.dataset.ageState !== 'verified')) return;
    loaded = true;
    const existing = [...document.querySelectorAll('script[src]')].some(script => {
      try { const url = new URL(script.src); return url.hostname === 'www.googletagmanager.com' && url.pathname === '/gtm.js' && url.searchParams.get('id') === id; } catch { return false; }
    });
    if (existing || window.google_tag_manager?.[id]) return;
    layer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(id);
    document.head.appendChild(script);
  }
  function sync() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    let analytics = false, marketing = false, sale = false;
    try {
      analytics = privacy.analyticsProcessingAllowed() === true;
      marketing = privacy.marketingAllowed() === true;
      sale = privacy.saleOfDataAllowed() === true;
    } catch { return; }
    const state = {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing && sale ? 'granted' : 'denied',
      ad_personalization: marketing && sale ? 'granted' : 'denied',
      personalization_storage: marketing && sale ? 'granted' : 'denied'
    };
    const key = JSON.stringify(state);
    if (key !== lastState) { consent('consent', 'update', state); lastState = key; }
    if (analytics && (config.scope === 'analytics' || marketing)) load();
  }
  function initializePrivacy() {
    if (window.Shopify?.customerPrivacy) { sync(); return; }
    if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) sync(); });
    } else if (++attempts < 20) {
      window.setTimeout(initializePrivacy, 250);
    }
    // No API or failed loading: keep the container blocked.
  }
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('beerclub:age-resolved', sync);
  window.addEventListener('pageshow', sync);
  initializePrivacy();
})();
